import React from 'react'
import { Flex, Box } from '@chatterbug/aaron'
import crown from './assets/crown.svg'

const getPillStyle = (isRankingShort: boolean) => {
  if (isRankingShort) {
    return {
      width: 24,
      height: 24,
      borderRadius: 'full',
    }
  } else {
    return {
      width: 30,
      height: 25,
      borderRadius: '1x',
      textAlign: 'center',
    }
  }
}

export type Props = {
  ranking: number
  showBlueBackground?: boolean
}

const RankingNumber: React.FC<Props> = ({ ranking, showBlueBackground }) => {
  const isRankingShort = String(ranking).length <= 3

  return (
    <Flex
      {...getPillStyle(isRankingShort)}
      alignItems="center"
      justifyContent="center"
      mr="1x"
      bg={showBlueBackground && 'blue70'}
      backgroundImage={ranking === 1 && `url(${crown})`}
      backgroundRepeat="no-repeat"
      minWidth="24px"
    >
      <Box fontSize="xxs" fontWeight="bold">
        {ranking}
      </Box>
    </Flex>
  )
}

export default RankingNumber
